import React, { useEffect } from 'react';
import SaversContentHeader from './SaversContentHeader';
import HeaderCashFlow from './HeaderCashFlow';
import SaversFooter from './SaversFooter';
import helpers from '../../../../services/helpers';
import "primereact/resources/themes/lara-light-blue/theme.css";
 
export default function LayoutCashFlow ({
        page_title='', 
        menu="", 
        breadcrumbs=true, 
        children, 
        parent_link='', 
        parent_text='',
        containerClass="container-fluid",
        header_title=true
    }){
    
    useEffect(() => {
        //Mounted
    }, []);

    
    return (
        <>
        {
            helpers.isAuthenticated() ? <HeaderCashFlow menu={menu} /> : ''
        }

        <div className="content-wrapper pb-3">
            {
                header_title ? <SaversContentHeader title={page_title} breadcrumbs={breadcrumbs}  parent_link={parent_link} parent_text={parent_text} containerClass={containerClass} /> : ''
            }
            
            <section className="content">
                {children}
            </section>

        </div>

        <SaversFooter />
        </>
    )
}